import Image from 'next/legacy/image';

import { SeparatedGrid } from './SeparatedGrid';

import { H4 } from '../../common/headline';

import ninetyPercent from '@public/img/our-story/ninety-percent.svg';
import fortyPercent from '@public/img/our-story/forty-percent.svg';
import fifteenLb from '@public/img/our-story/fifteen-lb.svg';
import calendar from '@public/img/our-story/calendar-multicoloured.svg';
import sugarCubes from '@public/img/our-story/sugar-cubes-multicoloured.svg';
import weightLoss from '@public/img/our-story/weight-loss-multicoloured.svg';

export const ResultsWithIcons = (): JSX.Element => (
  <div className="bg-salmon px-[20px] text-center text-blue lg:px-0">
    <SeparatedGrid
      borderColour="border-salmon-400"
      content={[
        <div
          key="ninety-percent"
          className="mr-[24px] flex flex-col items-center"
        >
          <div className="mt-8 flex h-fit items-center">
            <div className="mr-[21px]">
              <Image src={calendar} width={53} height={53} alt="calendar" />
            </div>
            <div>
              <Image src={ninetyPercent} width={105} height={72} alt="90%" />
            </div>
          </div>
          <div className="mt-3 max-w-[312px] lg:mt-0">
            <H4>
              of members lose weight and keep it off for more than 12 months.
            </H4>
          </div>
        </div>,
        <div
          key="forty-percent"
          className="mr-[24px] flex flex-col items-center"
        >
          <div className="mt-8 flex h-fit items-center">
            <div className="mr-[17px]">
              <Image
                src={sugarCubes}
                width={59}
                height={62}
                alt="Sugar cubes"
              />
            </div>
            <div>
              <Image src={fortyPercent} width={105} height={72} alt="40%" />
            </div>
          </div>
          <div className="mt-3 max-w-[312px] lg:mb-[20px] lg:mt-0">
            <H4>
              saw a drop in blood sugar levels below the type 2 diabetes
              threshold in the first three months.
            </H4>
          </div>
        </div>,
        <div key="ninety-percent" className="flex flex-col items-center">
          <div className="mt-8 flex h-fit items-center">
            <div className="mr-[18px]">
              <Image
                src={weightLoss}
                width={56}
                height={53}
                alt="Weighing scales"
              />
            </div>
            <div>
              <Image src={fifteenLb} width={105} height={72} alt="15lbs" />
            </div>
          </div>
          <div className="mt-3 max-w-[312px] lg:mt-0">
            <H4>
              lost on average at 12 months. That’s around 6.8kg in body weight.
            </H4>
          </div>
        </div>,
      ]}
    />
  </div>
);
